/**
 * 即构版权音乐
 * */
import { isObject } from 'lodash-es';
import { message } from 'antd';
import {
  getLocalStorageAdjustConfig,
  setLocalStorageAdjustConfig,
} from '../../components/ClickToSing/MusicAdjustModal';
import { _anly_seng_custom } from '../Action';
import Util from '../../script/util';

// 版权音乐错误码
const COPYRIGHT_MUSIC_ERROR_CODE = {
  1017019: '下载资源已过期，即将重新下载',
  1017014: '资源文件已过期，即将重新下载',
  1017015: '资源文件已损坏，即将重新下载',
  1017030: '音乐无版权，无法收听和点唱歌曲，联系主持跟换歌曲',
  1017031: '音乐无伴奏权限，只能收听歌曲，无法点唱，联系主持跟换歌曲',
  1017033: '该歌曲没有伴奏资源',
  1017034: '找不到该歌曲资源，请跟换歌曲',
  1017048: '获取歌词失败，请稍后重试',
  1017052: '无该歌曲版权，无法使用',
  1017098: '网络异常，请稍后重试',
  1017012: '有相同的资源正在下载中，请等待下载完成后重试~',
};

class ZegoWebCopyrightMusic {
  constructor(props) {
    this.props = props;

    this.musicMedia = null; // 媒体播放器
    this.musicPlaying = false; // 媒体播放器是否在播放中
    this.nowMusicResourceInfo = null; // 观众端当前播放的资源信息
    this.downloadMusicList = null; // 下载的歌曲列表

    this.localCopyMusicContent = document.querySelector(
      '#local_copy_music_content'
    ); // 存放媒体播放器的容器

    // 混响枚举
    this.musicPresetEnum = [
      { title: '3D', code: -1, codeNum: -1 },
      { title: 'KTV', code: 7, codeNum: 7 },
      { title: '摇滚', code: 9, codeNum: 9 },
      { title: '演唱会', code: 10, codeNum: 10 },
      { title: '录音棚', code: 5, codeNum: 5 },
    ];

    this.initCopyrightedMusic();
  }

  /**
   * 初始化版权音乐
   * */
  initCopyrightedMusic = async () => {
    try {
      const roomInfo = this.props.room;
      const pidConfig = roomInfo?.baseRoomInfo?.zegoKey
        ? await Util.decryptContent(roomInfo.baseRoomInfo.zegoKey)
        : null;
      const pinConfigMap = {};
      if (pidConfig?.length) {
        pidConfig.forEach((n) => {
          pinConfigMap[n.pidKey] = n.pidValue;
        });
      }
      this.props.client.setEngineConfig({
        advancedConfig: pinConfigMap,
      });
      this.CopyrightedMusic = this.props.client.createCopyrightedMusic();
      await this.CopyrightedMusic.initCopyrightedMusic({
        user: this.props.zegoUser,
      });
      this.musicPlaying = false; // 版权音乐播放器状态
      this.bindEvent();
    } catch (err) {
      console.error('加载版权音乐失败:', err);
    }
  };

  /**
   * 绑定事件
   * */
  bindEvent = () => {
    // 监听SEI数据
    this.props.client.on('playerRecvSEI', (streamID, data) => {
      try {
        if (streamID === this.props.streamID) {
          // 当前演唱的是我自己无需解析SEI
        } else {
          /*
           * json格式
           * {
           *  "keyProcessInMs": number, // 歌曲进度，单位毫秒
           *  "keyTotalInMs": number, // 歌曲总时长，单位毫秒
           *  "krc_token": string|null, // 即构歌曲歌词token
           *  "resourceID": string, // 即构歌曲资源ID
           *  "vendorSongID": string, // 即构歌曲ID
           *  "vendorID": string, // 即构歌曲供应商ID
           *  "songID": string, // 我们自己的歌曲ID
           *  "songName": string, // 即构歌曲名称
           *  "singerName": string, // 即构歌曲歌手
           * }
           * */
          const decoder = new TextDecoder().decode(data.slice(4));
          const json = JSON.parse(decoder);
          if (
            json &&
            this?.nowMusicResourceInfo?.vendorSongID !== json?.vendorSongID
          ) {
            this.nowMusicResourceInfo = json;
          }

          if (this.nowMusicResourceInfo && json.keyProcessInMs != null) {
            this.props.room.events['COPYRIGHT_MUSIC_PROCESS'] &&
              this.props.room.events['COPYRIGHT_MUSIC_PROCESS'](
                json.keyProcessInMs
              );
          }
        }
      } catch (error) {
        console.error('解析SEI失败', error);
      }
    });
  };
  /**
   * 移除事件
   * */
  removeEvent = () => {
    this.props.client.off('playerRecvSEI');
  };

  /**
   * 初始化版权音乐媒体播放器
   * */
  createMusicMedia = () => {
    // 版权音乐媒体播放器
    this.musicMedia = new CreateMediaPlayer(this.props);
    this.musicMedia.setProgressInterval(90);

    this.musicMedia.on('onMediaPlayerPlayingProgress', (info) => {
      const { millisecond } = info;
      this.props.room.events['COPYRIGHT_MUSIC_PROCESS'] &&
        this.props.room.events['COPYRIGHT_MUSIC_PROCESS'](millisecond);
      this.syncNowMusicLyrics(millisecond);
    });
    this.musicMedia.on('onMediaPlayerDuration', ({ duration }) => {
      // console.info("onMediaPlayerDuration", duration);
    });
    this.musicMedia.on('onMediaPlayerStateUpdate', ({ state, errorCode }) => {
      if (errorCode != null) {
        console.error('onMediaPlayerStateUpdate', state, errorCode);
      }
      // 0: 不在播放 Playing: 1 Pausing: 2 PlayEnded: 3
      if (state === 0) {
        // 不在播放
        this.musicPlaying = false;
      } else if (state === 1) {
        // 播放中
        this.musicPlaying = true;
      } else if (state === 2) {
        // 暂停播放
        this.musicPlaying = false;
        if (errorCode === 1 && this.songID) {
          this.deleteDownloadMusicList(this.songID);
          message.error('歌曲播放失败，请重新开始演唱');
        }
      } else if (state === 3) {
        // 结束播放
        this.musicPlaying = false;
        this.props.room.events['COPYRIGHT_MUSIC_PLAY_END'] &&
          this.props.room.events['COPYRIGHT_MUSIC_PLAY_END']();
      }
    });
  };

  /**
   * 获取音乐资源
   * @param songInfo 我们自己数据的歌曲信息
   * @param data 即构的歌曲信息
   * */
  async getMusicResource(songInfo, data, callback) {
    const { songId, songName, singerName } = songInfo;
    const curMusicRequestConfig = this.getDownloadMusicList(
      songId,
      'musicResourceInfo'
    );
    const result = data;
    if (
      curMusicRequestConfig &&
      result?.vendorSongId === curMusicRequestConfig?.vendorSongID
    ) {
      //  已缓存歌曲数据
      callback && callback({ errorCode: 0 });
    } else {
      if (result?.vendorSongId) {
        const musicRequestConfig = {
          songID: result.vendorSongId,
          vendorID: result.vendorId,
          mode: result.webBillingMode,
        };
        // mode: 计费模式; 0: 按次计费 1: 按用户包月计费 2: 按房间包月计费 3: 按房主包月计费
        if (result.webBillingMode === 3) {
          if (!this.props.zegoUser.userID) {
            callback && callback({ errorCode: -1 });
            message.warning(`异常，请稍后操作或重新添加歌曲`);
            return;
          }
          musicRequestConfig.masterID = this.props.zegoUser.userID;
        }
        this.songID = result?.vendorSongId || this.songID;
        const typeSong = 1;
        this.CopyrightedMusic.requestResource(musicRequestConfig, typeSong)
          .then((res) => {
            if (res?.errorCode === 0) {
              const resource = res.resource;
              const resources = resource.data.resources;
              const len = resources?.length ?? 0;
              if (len === 0) {
                message.error('歌曲资源获取失败');
                console.error('获取歌曲资源列表获取失败', res);
              } else {
                const index =
                  this.props?.room?.baseRoomInfo?.chooseQualityLevel === 1
                    ? len - 1
                    : 0; // 选择第几个音乐资源
                const musicResourceID = resources[index].resource_id;

                // 用于同步歌词
                const musicResourceInfo = {
                  krc_token: resource.data?.krc_token ?? null,
                  resourceID: musicResourceID,
                  vendorSongID: musicRequestConfig.songID,
                  vendorID: musicRequestConfig.vendorID,
                  songID: songId,
                  songName: songName,
                  singerName: singerName,
                };
                this.saveDownloadMusicList(songId, { musicResourceInfo });
              }
            } else {
              _anly_seng_custom(1900, {
                data: { res, resource: { data, musicRequestConfig } },
              });
              let errorText = '获取歌曲资源失败，请稍后重试';
              if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
                errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
              }
              message.error(errorText);
              console.error('获取歌曲资源失败', res);
            }
            callback && callback(res);
          })
          .catch((err) => {
            callback && callback(err);
          });
      } else {
        message.warning('请正确选择音乐');
      }
    }
  }

  /**
   * 下载歌曲
   * @param {string} songId 我们自己的songId
   * @param {string} originID 我们自己的ID
   * @param {function} calllback 回调
   * */
  downloadMusic = (songId, originID, callback = null) => {
    const musicResourceInfo = this.getDownloadMusicList(
      songId,
      'musicResourceInfo'
    );
    if (musicResourceInfo?.resourceID) {
      this.CopyrightedMusic.download(musicResourceInfo.resourceID).then(
        (res) => {
          if (res?.errorCode === 0) {
            this.saveDownloadMusicList(songId, { urls: res.urls });
          } else if (
            res?.errorCode === 1017019 ||
            res?.errorCode === 1017014 ||
            res?.errorCode === 1017015
          ) {
            message.warning(COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]);
            this.deleteDownloadMusicList(songId);
          } else if (res?.errorCode === 1017012) {
            message.warning(COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]);
          } else {
            let errorText = '下载歌曲资源失败，请稍后重试';
            if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
              errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
            }
            message.error(errorText);
          }
          callback && callback(res);
          this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'] &&
            this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'](
              res?.errorCode === 0,
              originID
            );
          if (res?.errorCode !== 0) {
            _anly_seng_custom(1901, {
              data: { res, resource: musicResourceInfo },
            });
            console.error('下载歌曲资源失败', musicResourceInfo, res);
          }
        }
      );
    } else {
      message.warning('歌曲资源异常，请重试下载');
      console.error('歌曲资源异常，请重试下载', musicResourceInfo);
      callback && callback({ errorCode: 1 });
      this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'] &&
        this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'](2, originID);
    }
  };
  /**
   * 加载音乐资源
   * */
  loadMusicResourceWith = (songId, callback) => {
    const musicResourceInfo = this.getDownloadMusicList(
      songId,
      'musicResourceInfo'
    );
    if (musicResourceInfo) {
      const urls = this.getDownloadMusicList(songId, 'urls');
      if (urls && urls.length && this.musicMedia) {
        this.musicMedia.load((res) => {
          this.nowMusicResourceInfo = musicResourceInfo;

          this.musicMedia.setAudioTrack(urls); // 设置音轨 替换 audio src 数据
          const audioTrackCount = this.musicMedia.getAudioTrackCount();
          if (audioTrackCount?.length === 1) {
            // 无伴奏，阻止控制切换 伴奏/原唱 空间
            setLocalStorageAdjustConfig('isOriginalVocal', true);
          }
          const accVolume = getLocalStorageAdjustConfig('accVolume');
          const voiceTone = getLocalStorageAdjustConfig('voiceTone');
          const isOpen3D = getLocalStorageAdjustConfig('isOpen3D') || false;
          if (accVolume === 0) {
            message.info('您当前演唱的歌曲音量为0哦，请前往调音台修改音量!');
          }
          this.changeMusicVolume(accVolume); // 设置媒体播放器音量
          this.changeHeadphoneMonitor(false); // 关闭耳返监听
          this.changeMusicPreset(0); // 重置音效
          this.enableLiveAudioEffect(!!isOpen3D);
          this.setVoiceChangerParam(voiceTone);
          this.startMusic();
          callback && callback({ errorCode: 0 });
        });
      } else {
        message.warning('歌曲资源获取异常');
        _anly_seng_custom(1903, {
          data: {
            res: { errorCode: 1 },
            resource: { musicResourceInfo, urls },
            musicMedia: !!this.musicMedia,
          },
        });
        callback && callback({ errorCode: 1 });
      }
    } else {
      message.warning('歌曲资源已失效，请重试开始演唱');
      callback && callback({ errorCode: 1 });
    }
  };
  /**
   * 开始播放
   * @param songId 我们自己的songId
   * */
  startMusic = () => {
    if (this.musicPlaying) {
      this.musicMedia.stop();
    }

    this.checkMusicOrigin(true, 'auto');
    this.nowCopyMusicDuration = this.musicMedia.getTotalDuration(); // 获取音乐时长
    this.musicMedia.start();
  };
  /**
   * 重唱
   * */
  againMusic = () => {
    if (this.musicMedia) {
      this.startMusic();
    }
  };
  /**
   * 获取逐行/逐字歌词
   * */
  getLrcLyric = (callback) => {
    if (this.nowMusicResourceInfo?.krc_token) {
      // 逐字歌词
      this.CopyrightedMusic.getKrcLyricByToken(
        this.nowMusicResourceInfo.krc_token
      ).then((res) => {
        if (res?.errorCode === 0) {
          if (res?.lyrics && typeof res.lyrics === 'string') {
            res.lyrics = JSON.parse(res.lyrics);
          }
        } else {
          _anly_seng_custom(1902, {
            data: { res, resource: this.nowMusicResourceInfo },
          });
          let errorText = '获取歌曲歌词失败，请稍后重试';
          if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
            errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
          }
          message.error(errorText);
          console.error('获取歌曲逐步歌词失败', res);
        }
        callback && callback(res);
      });
    } else if (this.nowMusicResourceInfo?.vendorSongID) {
      // 逐行歌词
      this.CopyrightedMusic.getLrcLyric(
        this.nowMusicResourceInfo.vendorSongID,
        this.nowMusicResourceInfo.vendorID
      ).then((res) => {
        if (res?.errorCode === 0) {
          if (res?.lyrics && typeof res.lyrics === 'string') {
            res.lyrics = JSON.parse(res.lyrics);
          }
        } else {
          _anly_seng_custom(1902, {
            data: { res, resource: this.nowMusicResourceInfo },
          });
          let errorText = '获取歌曲歌词失败，请稍后重试';
          if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
            errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
          }
          message.error(errorText);
          console.error('获取歌曲逐行歌词失败', res);
        }
        callback && callback(res);
      });
    } else {
      // 无法正确获取歌词
      message.warning('未获取到当前音乐，请重试');
      console.warn('未获歌词数据异常', this.nowMusicResourceInfo);
      callback(null);
    }
  };

  /**
   * 开始滚动歌词
   * @param {zegoViewInstance} zegoLyricInstance 即构歌词组件实例
   * @param {number} currentTime 歌词当前时间
   * */
  startRollingLyrics(zegoLyricInstance, currentTime) {
    // 更新本地歌词播放进度
    zegoLyricInstance.setCurrentTimeMillis(currentTime);
  }
  /**
   * 演唱者同步歌词进度
   * @param {number} currentTime 歌词进度
   * */
  syncNowMusicLyrics = (currentTime) => {
    if (this.musicPlaying) {
      // 将歌词播放进度通过 SEI 传出去
      const info = {
        keyProcessInMs: currentTime,
        keyTotalInMs: this.musicMedia.duration * 1000,
        ...(this.nowMusicResourceInfo || {}),
      };
      this.props.client.sendSEI(
        this.props.streamID,
        new TextEncoder().encode(JSON.stringify(info))
      );
    }
  };
  /**
   * 切换伴奏和原唱
   * @param {boolean} isOrigin 是否开启原唱
   * @param {string} source 来源
   * @param {function|null} callback 回调
   * */
  checkMusicOrigin = (isOrigin = false, source, callback = null) => {
    if (this.musicMedia) {
      const getAudioTrackCount = this.musicMedia.getAudioTrackCount();
      if (getAudioTrackCount === 1) {
        // 如果只有一个音轨，则无法切换伴奏
        this.musicMedia.setAudioTrackIndex(1);
        if (!isOrigin) {
          message.warning('当前没有伴奏，无法切换哦~');
          callback && callback('error');
        } else {
          callback && callback();
        }
      } else {
        if (source === 'auto') {
          const isOriginalVocal =
            getLocalStorageAdjustConfig('isOriginalVocal') ?? true;
          this.musicMedia.setAudioTrackIndex(isOriginalVocal ? 1 : 0);
        } else if (isOrigin) {
          this.musicMedia.setAudioTrackIndex(1);
        } else {
          this.musicMedia.setAudioTrackIndex(0);
        }
        callback && callback();
      }
    } else {
      message.warning('当前没有正在播放的歌曲，无法切换哦~');
      callback && callback();
    }
  };
  /**
   * 修改音量
   * @param {number} volume 音量
   * */
  changeMusicVolume = (volume = 60) => {
    if (this.musicMedia) {
      volume = volume == null ? 60 : Number(volume);
      this.musicMedia.setVolume(volume);
    } else {
      message.warning('当前没有正在播放的歌曲, 无法调整音量哦~');
    }
  };
  /**
   * 设置耳返
   * @param {boolean} enable 是否开启耳返
   * */
  changeHeadphoneMonitor = (enable = false) => {
    // WEB 无需耳返效果
    // this.props.client.enableHeadphoneMonitor(!!enable);
  };
  /**
   * 设置混响
   * @param {this.musicPresetEnum.code} preset 音量
   * */
  changeMusicPreset = (preset = 0) => {
    if (preset === -1) {
      // 虚拟立体声
      this.changeMusicVirtualStereo(true, -1);
      this.props.client.setReverbPreset(this.props.localStream, 0);
    } else if (preset === 0) {
      // 关闭混响
      this.changeMusicVirtualStereo(false); // 关闭虚拟立体声
      this.props.client.setReverbPreset(this.props.localStream, 0);
    } else {
      // 设置混响
      this.changeMusicVirtualStereo(false); // 关闭虚拟立体声
      this.props.client.setReverbPreset(this.props.localStream, preset);
    }
  };
  /**
   * 设置虚拟立体声
   * */
  changeMusicVirtualStereo = (enable = false, angle = -1) => {
    this.props.client.enableVirtualStereo(
      this.props.localStream,
      !!enable,
      angle
    );
  };
  /**
   * 开启关闭音效增强
   * @param player {HTMLMediaElement} 媒体播放器HTML
   * @param enable {boolean} 是否开启
   * @param mode {ZegoLiveAudioEffectMode} 类型
   * */
  enableLiveAudioEffect = (enable, mode = 3) => {
    this.props.client.enableLiveAudioEffect(
      this.musicMedia.songPlayer,
      !!enable,
      mode
    );
  };

  /**
   * 变声处理
   * @param voiceParam {number} 音调参数 [-12.0, 12.0]
   * */
  setVoiceChangerParam = (voiceParam) => {
    this.props.client.setVoiceChangerParam(this.props.localStream, voiceParam);
  };

  /**
   * 歌曲变调
   * @param dom {HTMLMediaElement} 媒体播放器HTML
   * @param voiceParam {number} 音调参数 [-12.0, 12.0]
   * @param mode {ZegoLiveAudioEffectMode} 音质增强生效模式 0: 都关闭 1: 仅生效本地 2: 仅生效推流 3: 本地和推流都生效
   * */
  setAudioChangerParam = (dom, voiceParam, mode = 3) => {
    this.props.client.setAudioChangerParam(dom, voiceParam, mode);
  };
  /**
   * 获取已经加载好，下载好的歌曲
   * */
  getDownloadMusicList = (songID, key) => {
    if (this.downloadMusicList && this.downloadMusicList[songID]) {
      if (key == null) {
        return this.downloadMusicList[songID];
      } else {
        return this.downloadMusicList[songID][key];
      }
    }
    return null;
  };
  /**
   * 保存已经加载好，下载好的歌曲
   * @param {string} songID 歌曲ID 我们自己的歌曲ID
   * @param {object} value 歌曲信息
   * */
  saveDownloadMusicList = (songID, value) => {
    if (this.downloadMusicList == null) this.downloadMusicList = {};
    const history = this.downloadMusicList[songID] || {};
    if (!history?.urls && value?.urls) {
      this.downloadMusicList[songID] = { ...history, ...value }; // 保存下载的音频信息
    } else {
      this.downloadMusicList[songID] = { ...history, ...value }; // 保存下载的音频信息
    }
  };
  /**
   * 删除已经加载好，下载好的歌曲
   * */
  deleteDownloadMusicList = (songID) => {
    if (isObject(this.downloadMusicList)) {
      const song = this.downloadMusicList[songID];
      if (song) {
        delete this.downloadMusicList[songID];
      }
    }
  };
  /**
   * 结束演唱
   * */
  endMusicPlaying = () => {
    if (this.musicMedia) {
      this.musicMedia.stop();
    }
    this.MusicPlaying = false;
    this.nowMusicResourceInfo = null;
  };

  /**
   * 销毁媒体播放器
   * */
  destroyMedia = () => {
    if (this.musicMedia) {
      this.endMusicPlaying();
      this.musicMedia.destroy();
      this.musicMedia = null;
      this.localCopyMusicContent.innerHTML = '';
    }
  };

  /**
   * 销毁版权音乐
   * */
  destroy = () => {
    this.removeEvent();
    this.destroyMedia();
    this.props.client.destroyCopyrightedMusic(this.CopyrightedMusic);
  };
}

export default ZegoWebCopyrightMusic;

// 创建媒体播放器类
class CreateMediaPlayer {
  constructor(props) {
    this.props = props;
    this.event = new EventListener();
    this.progressInterval = 1000; // 进度条更新间隔
    this.mediaPlayerPlayingProgressTimer = null; // 媒体播放器进度条定时器
    this.songPlayer = null; // 歌曲播放器
    this.accompanyPlayer = null; // 伴奏播放器
    this.isNotSong = false; // 是否有原唱
    this.isNotAccompany = false; // 是否有伴奏
    this.isPlaying = false; // 是否正在播放

    this.localCopyMusicContent = document.querySelector(
      '#local_copy_music_content'
    ); // 存放媒体播放器的容器

    this.initAudioConfig();
  }

  // 初始化创建媒体播放器
  initAudioConfig = () => {
    this.songPlayer = this.createAudioElement('songPlayer'); // 歌曲播放器
    this.accompanyPlayer = this.createAudioElement('accompanyPlayer'); // 伴奏播放器

    this.props.addMixingAudioID(['#songPlayer', '#accompanyPlayer']);
    this.props.changeMixingAudio(true);

    this.audioEventListener();
  };

  // 添加媒体播放器事件
  audioEventListener = () => {
    // onMediaPlayerStateUpdate 0: 不在播放 1: 播放中 2: 暂停播放 3: 播放结束
    // 可以正常开始播放
    this.songPlayer.addEventListener('canplay', this.eventCanplay);
    // 可以获取播放进度
    this.songPlayer.addEventListener(
      'durationchange',
      this.eventDurationChange
    );
    // 播放结束
    this.songPlayer.addEventListener('ended', this.eventEnded);
    // 播放错误
    this.songPlayer.addEventListener('error', this.eventError);
    // 播放暂停
    this.songPlayer.addEventListener('pause', this.eventPause);
    // 播放开始
    this.songPlayer.addEventListener('play', this.eventPlay);
  };
  eventCanplay = () => {
    // console.info("songPlayer canplay");
  };
  eventDurationChange = () => {
    const duration = this.songPlayer.duration;
    this.event.dispatchEvent('onMediaPlayerDuration', {
      duration: duration * 1000,
    });
  };
  eventEnded = () => {
    this.isPlaying = false;
    this.event.dispatchEvent('onMediaPlayerStateUpdate', { state: 3 });
    clearInterval(this.mediaPlayerPlayingProgressTimer);
    this.mediaPlayerPlayingProgressTimer = null;
  };
  eventError = () => {
    this.isPlaying = false;
    this.event.dispatchEvent('onMediaPlayerStateUpdate', {
      state: 2,
      errorCode: 1,
    });
    clearInterval(this.mediaPlayerPlayingProgressTimer);
    this.mediaPlayerPlayingProgressTimer = null;
  };
  eventPause = () => {
    this.isPlaying = false;
    this.event.dispatchEvent('onMediaPlayerStateUpdate', { state: 2 });
    clearInterval(this.mediaPlayerPlayingProgressTimer);
    this.mediaPlayerPlayingProgressTimer = null;
  };
  eventPlay = () => {
    this.isPlaying = true;
    this.event.dispatchEvent('onMediaPlayerStateUpdate', { state: 1 });

    // 歌词进度回调
    if (this.songPlayer && this.mediaPlayerPlayingProgressTimer == null) {
      this.mediaPlayerPlayingProgressTimer = setInterval(() => {
        if (this.songPlayer) {
          let currentTime = this.songPlayer.currentTime;
          currentTime = parseInt(currentTime * 1000, 10);
          this.event.dispatchEvent('onMediaPlayerPlayingProgress', {
            millisecond: currentTime,
          });
        } else {
          clearInterval(this.mediaPlayerPlayingProgressTimer);
          this.mediaPlayerPlayingProgressTimer = null;
        }
      }, this.progressInterval);
    }
  };

  // 创建媒体播放器 DOM
  createAudioElement = (id) => {
    const dom = this.localCopyMusicContent.querySelector(id);
    if (dom) return dom;
    const audio = document.createElement('audio');
    audio.id = id;
    audio.setAttribute('playsinline', 'true');
    audio.style.display = 'none';
    this.localCopyMusicContent.appendChild(audio);
    return audio;
  };

  /*
   * 音频回调
   * @param {string} eventName 事件名称
   * */
  on = (eventName, fn) => {
    this.event.addEventListener(eventName, fn);
  };
  /**
   * 移除音频回调
   * @param {string} eventName 事件名称
   * */
  deleteEvent = (eventName) => {
    this.event.removeEventListener(eventName);
  };
  // 加载歌曲
  load = (callback) => {
    this.songPlayer.load();
    if (!!this.isNotAccompany) this.accompanyPlayer.load();
    callback && callback();
  };
  // 开始播放
  start = () => {
    this.songPlayer.play();
    if (!!this.isNotAccompany) this.accompanyPlayer.play();
  };
  // 暂停播放
  pause = () => {
    if (!!this.isPlaying) {
      this.songPlayer.pause();
      if (!!this.isNotAccompany) this.accompanyPlayer.pause();
    }
  };
  // 停止播放
  stop = () => {
    this.pause();
    this.setCurrentTime(0);
  };
  /**
   * 设置音量
   * @param {number} volume 设置音量
   * */
  setVolume = (volume) => {
    this.props.client.setMixingAudioVolume(
      this.props.streamID,
      volume,
      this.songPlayer
    );
    this.songPlayer.volume = volume / 100;
    if (!!this.isNotAccompany) {
      this.props.client.setMixingAudioVolume(
        this.props.streamID,
        volume,
        this.accompanyPlayer
      );
      this.accompanyPlayer.volume = volume / 100;
    }
  };
  /**
   * 设置进度条更新间隔
   * @param {number} interval 设置进度条更新间隔（ms）
   * */
  setProgressInterval(interval) {
    this.progressInterval = interval;
  }
  // 获取播放进度
  getTotalDuration = () => {
    return this.songPlayer.duration;
  };
  /**
   * 设置播放进度
   * @param {number} currentTime 设置播放进度
   * */
  setCurrentTime = (currentTime) => {
    if (currentTime > this.getTotalDuration()) {
      currentTime = 0;
    }
    this.songPlayer.currentTime = currentTime;
    if (!!this.isNotAccompany) this.accompanyPlayer.currentTime = currentTime;
  };
  // 查询音轨数量
  getAudioTrackCount = () => {
    let count = 0;
    if (this.isNotSong) {
      count++;
    }
    if (this.isNotAccompany) {
      count++;
    }
    return count;
  };
  /**
   * 设置音轨
   * @param {[]} urls 音轨列表
   * */
  setAudioTrack = (urls) => {
    const len = urls?.length ?? 0;
    if (len === 1) {
      // 无伴奏
      this.songPlayer.src = urls[0];
      this.accompanyPlayer.src = null;
      this.isNotSong = true;
      this.isNotAccompany = false;
    } else if (len === 2) {
      this.songPlayer.src = urls[1];
      this.accompanyPlayer.src = urls[0];
      this.isNotSong = true;
      this.isNotAccompany = true;
    }
  };
  /**
   * 切换音轨
   * @param {number} index 0: 伴奏 1: 原唱
   * */
  setAudioTrackIndex = (index) => {
    if (index === 0) {
      this.songPlayer.muted = true;
      this.accompanyPlayer.muted = false;
    } else if (index === 1) {
      this.songPlayer.muted = false;
      this.accompanyPlayer.muted = true;
    }
  };

  // 销毁
  destroy = () => {
    if (this.songPlayer) {
      this.songPlayer.removeEventListener('canplay', this.eventCanplay);
      this.songPlayer.removeEventListener(
        'durationchange',
        this.eventDurationChange
      );
      this.songPlayer.removeEventListener('ended', this.eventEnded);
      this.songPlayer.removeEventListener('error', this.eventError);
      this.songPlayer.removeEventListener('pause', this.eventPause);
      this.songPlayer.removeEventListener('play', this.eventPlay);
    }
    this.stop();
    this.isNotSong = false;
    this.isNotAccompany = false;
    this.songPlayer = null;
    this.accompanyPlayer = null;
    this.event.destroy();
    this.event = null;
    // 关闭版权音乐的混流
    this.props.changeMixingAudio(false, [
      this.songPlayer,
      this.accompanyPlayer,
    ]);
  };
}

// 事件监听
class EventListener {
  constructor() {
    this.events = {};
  }

  /**
   * 添加事件监听
   * @param {string} eventName 事件名称
   * @param {function} callback 回调函数
   * */
  addEventListener = (eventName, callback) => {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  };

  /**
   * 移除事件监听
   * @param {string} eventName 事件名称
   * @param {function} callback 回调函数
   * */
  removeEventListener = (eventName, callback) => {
    if (!this.events[eventName]) return;
    const index = this.events[eventName].findIndex((item) => item === callback);
    if (index !== -1) {
      this.events[eventName].splice(index, 1);
    }
  };

  /**
   * 触发事件
   * @param {string} eventName 事件名称
   * @param {object} data 回调函数参数
   * */
  dispatchEvent = (eventName, data) => {
    if (!this.events[eventName]) return;
    this.events[eventName].forEach((callback) => {
      callback(data);
    });
  };

  /**
   * 销毁事件监听
   * */
  destroy = () => {
    this.events = null;
  };
}
